import type { Account, WalletAsset } from "../asset";
import type { Currency } from "../currency";
import type { PaymentMethod } from "../payment-method";
import type { UserProfile } from "../profile";
import type { Trade, TradeType } from "../trade";

export interface AdvertisementTerm {
  id: string;
  advertisementId: string;
  advertisement?: Advertisement;
  title?: string | null;
  description: string;
  order: number;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string | null;
}

export const PriceType = {
  FIXED: "FIXED",
  FLOATING: "FLOATING",
} as const;

export type PriceType = (typeof PriceType)[keyof typeof PriceType];

export const TradeReserveSource = {
  AD_BACKED: "AD_BACKED",
  USER_BACKED: "USER_BACKED",
} as const;

export type TradeReserveSource =
  (typeof TradeReserveSource)[keyof typeof TradeReserveSource];

export const AdvertiserTier = {
  BASIC: "BASIC",
  VERIFIED: "VERIFIED",
  TRUSTED: "TRUSTED",
  BUSINESS_BASIC: "BUSINESS_BASIC",
  BUSINESS_VERIFIED: "BUSINESS_VERIFIED",
  BUSINESS_ENTERPRISE: "BUSINESS_ENTERPRISE",
} as const;

export type AdvertiserTier =
  (typeof AdvertiserTier)[keyof typeof AdvertiserTier];

export const AdStatus = {
  ACTIVE: "ACTIVE",
  PAUSED: "PAUSED",
  CLOSED: "CLOSED",
} as const;

export type AdStatus = (typeof AdStatus)[keyof typeof AdStatus];

export interface Advertisement {
  id: string;
  userId: string;
  user?: UserProfile | null;
  type: TradeType;
  assetId: string;
  asset?: WalletAsset | null;
  fiatCurrencyId: string;
  fiatCurrency?: Currency | null;
  priceType: PriceType;
  price?: string | null;
  minAmount: string;
  maxAmount: string;
  totalAmount: string;
  available?: number;
  paymentWindow: number;
  floatingMargin: number;
  paymentMethods?: PaymentMethod[];
  status: string;
  terms?: AdvertisementTerm[];
  reserveSource: TradeReserveSource;
  trades?: Trade[];
  createdAt: string;
  updatedAt: string;
  deletedAt?: string | null;
}

export interface AdvertisementMeta {
  hasNextPage: boolean;
  hasPrevPage: boolean;
  limit: number;
  page: number;
  total: number;
  totalPages: number;
}

export interface AdvertisementInterface {
  data: Advertisement[];
  meta: AdvertisementMeta;
}
